import { Col, Row } from "antd";

import "./styles.scss";

const PointsSection = () => {
  return (
    <section className="points-section">
      <div className="points-section-inner container">
        <Row gutter={[30, 30]}>
          {points.map((point, index) => (
            <Col xs={24} sm={12} md={8} lg={6} key={index}>
              <PointCard {...point} number={index + 1} />
            </Col>
          ))}
        </Row>
      </div>
    </section>
  );
};

export default PointsSection;

const PointCard = ({ title, number, description }) => (
  <div className="point-card">
    <span className="pc-number">0{number}</span>
    <h3>{title}</h3>
    <p className="jakarta-sans-font text-black-subtle line-height-medium font-18">
      {description}
    </p>
  </div>
);

const points = [
  {
    title: "Empathy",
    description:
      "We listen, understand, and empathize. Your challenges become ours, and your  victories are our celebrations",
  },
  {
    title: "Innovation",
    description:
      "We thrive on curiosity and creativity. Our team constantly explores new horizons to  bring you fresh solutions",
  },
  {
    title: "Integrity",
    description:
      "Trust is our foundation. We uphold the highest ethical standards in every interaction.",
  },
  {
    title: "Collaboration",
    description:
      "We believe in synergy. Let’s co-create, learn, and grow together",
  },
];
